// extracted by mini-css-extract-plugin
export default {"List":"FeatureSec_List__mfEng","Listflex":"FeatureSec_Listflex__5vaOq","ListItems":"FeatureSec_ListItems__CVZg4","FeatureContainer":"FeatureSec_FeatureContainer__DQSQq"};